import { BarChart3, BookOpenCheck, Globe2, ListMusic, MessageSquareText, Settings } from 'lucide-react'

export type AppScreen = 'home' | 'library' | 'progress' | 'settings' | 'feedback'

type HeaderProps = {
  active: AppScreen | 'session'
  onNavigate: (screen: AppScreen) => void
}

export function Header({ active, onNavigate }: HeaderProps) {
  return (
    <header className="site-header">
      <button className="brand" type="button" onClick={() => onNavigate('home')} aria-label="TonalTutor home">
        <span className="brand-mark" aria-hidden="true">T</span>
        <span>
          <strong>TonalTutor</strong>
        </span>
      </button>

      <nav className="primary-nav" aria-label="Main navigation">
        <button className={active === 'home' ? 'nav-button active' : 'nav-button'} type="button" onClick={() => onNavigate('home')}>
          <ListMusic aria-hidden="true" /> <span>Exercises</span>
        </button>
        <button className={active === 'library' ? 'nav-button active' : 'nav-button'} type="button" onClick={() => onNavigate('library')}>
          <BookOpenCheck aria-hidden="true" /> <span>Curriculum</span>
        </button>
        <button className={active === 'progress' ? 'nav-button active' : 'nav-button'} type="button" onClick={() => onNavigate('progress')}>
          <BarChart3 aria-hidden="true" /> <span>Progress</span>
        </button>
        <button className={active === 'feedback' ? 'nav-button active' : 'nav-button'} type="button" onClick={() => onNavigate('feedback')}>
          <MessageSquareText aria-hidden="true" /> <span>Feedback</span>
        </button>
        <button className="nav-button language-button" type="button" title="English — more languages are being prepared" aria-label="Language: English">
          <Globe2 aria-hidden="true" /> <span>English</span>
        </button>
        <button className={active === 'settings' ? 'nav-button active' : 'nav-button'} type="button" onClick={() => onNavigate('settings')}>
          <Settings aria-hidden="true" /> <span>Options</span>
        </button>
      </nav>
    </header>
  )
}
